/**
 * @see https://github.com/referenceable/referenceable_api/blob/feat/mindtickle-storage-providers/app/models/storage_provider.rb#L24-L35
 */
export enum StorageProviders {
  Box = 'Box',
  Gong = 'Gong',
  GoogleDrive = 'GoogleDrive',
  MyDevice = 'MyDevice',
  MindTickleAssets = 'MindtickleAssetsPicker',
  MindTickleCalls = 'MindtickleCallsPicker',
  OneDrive = 'OneDrive',
  RingCentral = 'RingCentral',
  SharePoint = 'SharePoint',
  Teams = 'Teams',
  Zoom = 'Zoom',
}

export enum StorageProvidersTracking {
  GoogleDrive = 'Google Drive',
}

export enum StorageProviderMTPickers {
  CallAi = 'call_ai',
  AssetHub = 'asset_hub',
}
